module.exports = __webpack_public_path__ + "static/media/Arrow.2f6447e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Arrow.png
// module id = 74
// module chunks = 0